
import { compareArrays, comparePrimitives, compare, equals } from "../../fable_modules/fable-library-js.5.13.0/Util.js";
import { Msg, WaveSimModel, WaveSimState } from "../../Model/ModelType.js";
import { getFastSim } from "../../Simulator/Simulator.js";
import { FastSimulation__ComponentOf_6546966D, SimulatedDesign__SoleInstanceOfSheet_Z721C83C5, SimulatedDesign__get_SheetInstanceCounts, FastSimulation__get_SimulatedTopSheet } from "../../Simulator/SimTypes.js";
import { normalFontStyle, boldFontStyle, ramRowStyle, checkboxInputProps, selectRamButtonPropsLight, selectRamButtonProps, selectWavesButtonPropsLight, selectWavesButtonProps } from "./WaveSimStyle.js";
import { delayedDispatch } from "../../Interface/JSHelpers.js";
import { isWaveSelected, isInsideLibraryComponent, makeWave, waveIndicesOfFComp, isRamSelected, button } from "./WaveSimHelpers.js";
import { sortBy, tryFind as tryFind_1, tryFindIndex, tail, head, isEmpty, choose, collect, append, map, empty, ofArray, singleton, length } from "../../fable_modules/fable-library-js.5.13.0/List.js";
import { isEmpty as isEmpty_1, tryFind, toList, ofList, add, remove } from "../../fable_modules/fable-library-js.5.13.0/Map.js";
import { Card_foot, Card_body, Card_title, Card_head, Card_card, background, Option, modal } from "../../fable_modules/Fulma.3.0.0/Components/Modal.fs.js";
import { HTMLAttr, DOMAttr } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Size_ISize, Common_GenericOption } from "../../fable_modules/Fulma.3.0.0/Common.fs.js";
import { right, left, level } from "../../fable_modules/Fulma.3.0.0/Layouts/Level.fs.js";
import { Option as Option_1, delete$ } from "../../fable_modules/Fulma.3.0.0/Elements/Delete.fs.js";
import * as react from "react";
import { colorSpan } from "../Style.js";
import { iSpan, bSpan } from "../UIPopups.js";
import { table as table_3 } from "../../fable_modules/Fulma.3.0.0/Elements/Table.fs.js";
import { input, checkbox } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Checkbox.fs.js";
import { keyValueList } from "../../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { memoizeByIdentity } from "../../Common/Helpers.js";
import { value as value_2, toArray, defaultArg } from "../../fable_modules/fable-library-js.5.13.0/Option.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.5.13.0/Result.js";
import { PortType } from "../../Common/CommonTypes.js";
import { getWSModel } from "../ModelHelpers.js";
import { tryItem } from "../../fable_modules/fable-library-js.5.13.0/Array.js";
import { dToInt } from "../../Common/Ids.js";
import { FastData, FastBits } from "../../Simulator/SimGraphTypes.js";
import { fastDataToPaddedString } from "../../Simulator/NumberHelpers.js";
import { nameOfPort, ofInstanceCached } from "../../Simulator/FastSim/PortView.js";
import { toUInt32 } from "../../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { concat } from "../../fable_modules/fable-library-js.5.13.0/String.js";
import { toggleWaveSelection, waveRow, wavePropsTable, waveIndicesOfInstance, waveIndicesOfInstanceBy } from "./WaveSimSelectHelpers.js";
import { selectorInstances } from "./WaveSimHierarchy.js";

/**
 * Button to activate wave selection modal
 */
export function selectWavesButton(wsModel, dispatch) {
    let fs;
    const patternInput = (equals(wsModel.State, WaveSimState.Success) && ((fs = getFastSim(), ((fs.NumStepArrays === 0) && (FastSimulation__get_SimulatedTopSheet(fs) !== "")) ? true : !(fs.WaveIndex.length === 0)))) ? [selectWavesButtonProps("selectButton")(true), (_arg) => {
        dispatch(new Msg(/* UpdateWSModel */ 13, [(ws) => (new WaveSimModel(ws.DefaultCursor, ws.WSConfig, ws.WSConfigDialog, ws.State, ws.WaveDetails, ws.SelectedWaves, ws.DefaultSelectionPending, ws.FetchFailedAtMs, ws.StartCycle, ws.ShownCycles, ws.SamplingZoom, ws.CursorDisplayCycle, ws.CursorExactClkCycle, ws.ClkCycleBoxIsEmpty, ws.Radix, ws.WaveformColumnWidth, true, ws.RamModalActive, ws.PortSelectComp, ws.RamComps, ws.SelectedRams, ws.RamStartLocation, ws.RamRows, ws.ShowSheetDetail, ws.SelectedSheetInstance, ws.ShowGroupDetail, ws.HoveredLabel, ws.DraggedIndex, ws.PrevSelectedWaves, ws.ScrollbarTbWidth, ws.ScrollbarTbPos, ws.ScrollbarTbOffset, ws.ScrollbarBkgWidth, ws.ScrollbarBkgRepCycs, ws.ScrollbarQueueIsEmpty, ws.SheetSearchString, ws.ComponentSearchString, ws.PortSearchString, ws.ShowOnlySelected))]));
        delayedDispatch(dispatch, 0, new Msg(/* UpdateWSModel */ 13, [(x) => x]));
    }] : [selectWavesButtonPropsLight("selectButton"), (_arg_1) => {
    }];
    return button(patternInput[0], patternInput[1], "Select Waves");
}

/**
 * Button to activate RAM selection modal.
 */
export function selectRamButton(wsModel, dispatch) {
    const patternInput = ((length(wsModel.RamComps) > 0) && equals(wsModel.State, WaveSimState.Success)) ? [selectRamButtonProps("selectRamButton"), (_arg) => {
        dispatch(new Msg(/* UpdateWSModel */ 13, [(ws) => (new WaveSimModel(ws.DefaultCursor, ws.WSConfig, ws.WSConfigDialog, ws.State, ws.WaveDetails, ws.SelectedWaves, ws.DefaultSelectionPending, ws.FetchFailedAtMs, ws.StartCycle, ws.ShownCycles, ws.SamplingZoom, ws.CursorDisplayCycle, ws.CursorExactClkCycle, ws.ClkCycleBoxIsEmpty, ws.Radix, ws.WaveformColumnWidth, ws.WaveModalActive, true, ws.PortSelectComp, ws.RamComps, ws.SelectedRams, ws.RamStartLocation, ws.RamRows, ws.ShowSheetDetail, ws.SelectedSheetInstance, ws.ShowGroupDetail, ws.HoveredLabel, ws.DraggedIndex, ws.PrevSelectedWaves, ws.ScrollbarTbWidth, ws.ScrollbarTbPos, ws.ScrollbarTbOffset, ws.ScrollbarBkgWidth, ws.ScrollbarBkgRepCycs, ws.ScrollbarQueueIsEmpty, ws.SheetSearchString, ws.ComponentSearchString, ws.PortSearchString, ws.ShowOnlySelected))]));
    }] : [selectRamButtonPropsLight("selectRamButton"), (_arg_1) => {
    }];
    return button(patternInput[0], patternInput[1], "Select RAM");
}

/**
 * Toggle if a RAM's contents is selected for viewing.
 * The selection is read from the model the update is applied to, not from the one this element
 * was rendered with, so that a change made between the two is not undone here.
 */
export function toggleRamSelection(ramId_, ramId__1, ramLabel, dispatch) {
    const ramId = [ramId_, ramId__1];
    return dispatch(new Msg(/* UpdateWSModel */ 13, [(ws) => (new WaveSimModel(ws.DefaultCursor, ws.WSConfig, ws.WSConfigDialog, ws.State, ws.WaveDetails, ws.SelectedWaves, ws.DefaultSelectionPending, ws.FetchFailedAtMs, ws.StartCycle, ws.ShownCycles, ws.SamplingZoom, ws.CursorDisplayCycle, ws.CursorExactClkCycle, ws.ClkCycleBoxIsEmpty, ws.Radix, ws.WaveformColumnWidth, ws.WaveModalActive, ws.RamModalActive, ws.PortSelectComp, ws.RamComps, isRamSelected(ramId[0], ramId[1], ws) ? remove(ramId, ws.SelectedRams) : add(ramId, ramLabel, ws.SelectedRams), ws.RamStartLocation, ws.RamRows, ws.ShowSheetDetail, ws.SelectedSheetInstance, ws.ShowGroupDetail, ws.HoveredLabel, ws.DraggedIndex, ws.PrevSelectedWaves, ws.ScrollbarTbWidth, ws.ScrollbarTbPos, ws.ScrollbarTbOffset, ws.ScrollbarBkgWidth, ws.ScrollbarBkgRepCycs, ws.ScrollbarQueueIsEmpty, ws.SheetSearchString, ws.ComponentSearchString, ws.PortSearchString, ws.ShowOnlySelected))]));
}

/**
 * Modal that, when active, allows users to select RAMs to view their contents.
 */
export function selectRamModal(wsModel, dispatch) {
    let s_10, children_8;
    getFastSim();
    return modal(ofArray([new Option(/* IsActive */ 1, [wsModel.RamModalActive]), new Option(/* Props */ 0, [singleton(["style", {
        zIndex: 20000,
    }])])]), ofArray([background(singleton(new Common_GenericOption(/* Props */ 1, [singleton(new DOMAttr(/* OnClick */ 40, [(_arg_2) => {
        dispatch(new Msg(/* UpdateWSModel */ 13, [(ws) => (new WaveSimModel(ws.DefaultCursor, ws.WSConfig, ws.WSConfigDialog, ws.State, ws.WaveDetails, ws.SelectedWaves, ws.DefaultSelectionPending, ws.FetchFailedAtMs, ws.StartCycle, ws.ShownCycles, ws.SamplingZoom, ws.CursorDisplayCycle, ws.CursorExactClkCycle, ws.ClkCycleBoxIsEmpty, ws.Radix, ws.WaveformColumnWidth, ws.WaveModalActive, false, ws.PortSelectComp, ws.RamComps, ws.SelectedRams, ws.RamStartLocation, ws.RamRows, ws.ShowSheetDetail, ws.SelectedSheetInstance, ws.ShowGroupDetail, ws.HoveredLabel, ws.DraggedIndex, ws.PrevSelectedWaves, ws.ScrollbarTbWidth, ws.ScrollbarTbPos, ws.ScrollbarTbOffset, ws.ScrollbarBkgWidth, ws.ScrollbarBkgRepCycs, ws.ScrollbarQueueIsEmpty, ws.SheetSearchString, ws.ComponentSearchString, ws.PortSearchString, ws.ShowOnlySelected))]));
    }]))])), empty()), Card_card(singleton(new Common_GenericOption(/* Props */ 1, [singleton(["style", {
        width: 800,
    }])])), ofArray([Card_head(empty(), singleton(Card_title(empty(), singleton(level(empty(), ofArray([left(empty(), singleton("Select RAM")), right(empty(), singleton(delete$(ofArray([new Option_1(/* Size */ 0, [Size_ISize.IsMedium]), new Option_1(/* OnClick */ 3, [(_arg_3) => {
        dispatch(new Msg(/* UpdateWSModel */ 13, [(ws_1) => (new WaveSimModel(ws_1.DefaultCursor, ws_1.WSConfig, ws_1.WSConfigDialog, ws_1.State, ws_1.WaveDetails, ws_1.SelectedWaves, ws_1.DefaultSelectionPending, ws_1.FetchFailedAtMs, ws_1.StartCycle, ws_1.ShownCycles, ws_1.SamplingZoom, ws_1.CursorDisplayCycle, ws_1.CursorExactClkCycle, ws_1.ClkCycleBoxIsEmpty, ws_1.Radix, ws_1.WaveformColumnWidth, ws_1.WaveModalActive, false, ws_1.PortSelectComp, ws_1.RamComps, ws_1.SelectedRams, ws_1.RamStartLocation, ws_1.RamRows, ws_1.ShowSheetDetail, ws_1.SelectedSheetInstance, ws_1.ShowGroupDetail, ws_1.HoveredLabel, ws_1.DraggedIndex, ws_1.PrevSelectedWaves, ws_1.ScrollbarTbWidth, ws_1.ScrollbarTbPos, ws_1.ScrollbarTbOffset, ws_1.ScrollbarBkgWidth, ws_1.ScrollbarBkgRepCycs, ws_1.ScrollbarQueueIsEmpty, ws_1.SheetSearchString, ws_1.ComponentSearchString, ws_1.PortSearchString, ws_1.ShowOnlySelected))]));
    }])]), empty())))])))))), Card_body(empty(), ofArray(["Select ROM or asynchronous RAM components to view their contents in any clock cycle. ", "Note that synchronous RAM components cannot currently be viewed in the waveform simulator. ", react.createElement("br", {}), react.createElement("br", {}), "On a write, the corresponding location will be ", colorSpan("red", "highlighted in red during the clock cycle in which the written value is first output."), " On a read, the corresponding location will be ", colorSpan("blue", "highlighted in blue."), react.createElement("br", {}), react.createElement("br", {}), "The RAM display has two modes: ", bSpan("sparse display"), " and ", bSpan("windowed display. "), react.createElement("br", {}), "Type in the", iSpan(" Window start"), " box to set the locations viewed in a window. Leave it blank for sparse display.", react.createElement("br", {}), react.createElement("br", {}), (s_10 = "If the RAM has too many non-zero locations to display all at once, the windowed display will be used.", s_10), react.createElement("hr", {}), table_3(empty(), singleton((children_8 = map((_arg) => {
        let children, children_4;
        const ramName = _arg[1];
        const ramId = _arg[0];
        const children_6 = [(children = [checkbox(empty(), singleton(input(singleton(new Common_GenericOption(/* Props */ 1, [append(checkboxInputProps, ofArray([new HTMLAttr(/* Checked */ 62, [isRamSelected(ramId[0], ramId[1], wsModel)]), new DOMAttr(/* OnChange */ 9, [(_arg_1) => {
            toggleRamSelection(ramId[0], ramId[1], ramName, dispatch);
        }])]))])))))], react.createElement("td", {}, ...children)), (children_4 = [react.createElement("label", keyValueList([ramRowStyle], 1), ramName)], react.createElement("td", {}, ...children_4))];
        return react.createElement("tr", {}, ...children_6);
    }, wsModel.RamComps), react.createElement("tbody", {}, ...children_8))))])), Card_foot(empty(), empty())]))]));
}

const canvasCompCopies = memoizeByIdentity((fs) => {
    const counts = SimulatedDesign__get_SheetInstanceCounts(fs.Design);
    const sheetOfComp = ofList(collect((tupledArg) => map((tupledArg_1) => [tupledArg_1[0], tupledArg[0]], toList(tupledArg[1])), toList(fs.Design.DesignComponentsById)), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const soleInstance = ofList(choose((tupledArg_2) => {
        const sheet_1 = tupledArg_2[0];
        if (tupledArg_2[1] === 1) {
            const option_1 = SimulatedDesign__SoleInstanceOfSheet_Z721C83C5(fs.Design, sheet_1);
            if (option_1 != null) {
                return [sheet_1, option_1];
            }
            else {
                return undefined;
            }
        }
        else {
            return undefined;
        }
    }, toList(counts)), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    });
    return (compId) => {
        const matchValue = tryFind(compId, sheetOfComp);
        if (matchValue != null) {
            const sheet_2 = matchValue;
            const matchValue_1 = tryFind(sheet_2, soleInstance);
            return (matchValue_1 == null) ? (new FSharpResult$2(/* Error */ 1, [defaultArg(tryFind(sheet_2, counts), 0)])) : (new FSharpResult$2(/* Ok */ 0, [[compId, matchValue_1]]));
        }
        else {
            return new FSharpResult$2(/* Error */ 1, [0]);
        }
    };
});

function copiesOfCanvasComp(fs, compId) {
    return canvasCompCopies(fs)(compId);
}

/**
 * The custom component instance a component sits directly inside, if any.
 * An access path is ordered innermost first, so its head is the instance the component is
 * immediately within and its tail is the path of the sheet that instance is drawn on.
 */
export function enclosingInstance(accessPath) {
    if (!isEmpty(accessPath)) {
        return [head(accessPath), tail(accessPath)];
    }
    else {
        return undefined;
    }
}

function waveOfInstancePort(fs, ws, fc) {
    let option_3, pNum, option_1;
    const portOfLabel = (labels) => tryFindIndex((tupledArg) => (tupledArg[0] === fc.FLabel), labels);
    const matchValue = fc.FType;
    const matchValue_1 = enclosingInstance(fc.fId[1]);
    let matchResult, instanceId;
    switch (matchValue.tag) {
        case 0: {
            if (matchValue_1 != null) {
                matchResult = 0;
                instanceId = matchValue_1;
            }
            else {
                matchResult = 1;
            }
            break;
        }
        case 1: {
            if (matchValue_1 != null) {
                matchResult = 0;
                instanceId = matchValue_1;
            }
            else {
                matchResult = 1;
            }
            break;
        }
        default:
            matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const matchValue_3 = FastSimulation__ComponentOf_6546966D(fs, instanceId);
            let matchResult_1, cc;
            if (matchValue_3 != null) {
                if (matchValue_3.FType.tag === 26) {
                    matchResult_1 = 0;
                    cc = matchValue_3.FType.fields[0];
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    const patternInput = (fc.FType.tag === 0) ? [PortType.Input, portOfLabel(cc.InputLabels)] : [PortType.Output, portOfLabel(cc.OutputLabels)];
                    return ofArray(toArray((option_3 = patternInput[1], (option_3 != null) ? ((pNum = (option_3 | 0), (option_1 = tryFind_1((wi) => {
                        if (equals(wi.PortType, patternInput[0])) {
                            return wi.PortNumber === pNum;
                        }
                        else {
                            return false;
                        }
                    }, waveIndicesOfFComp(fs, instanceId[0], instanceId[1])), (option_1 != null) ? makeWave(ws, fs, option_1) : undefined))) : undefined)));
                }
                default:
                    return empty();
            }
        }
        default:
            return empty();
    }
}

/**
 * The waves to offer for one component on the canvas, and the number of copies of that component
 * the simulation holds. A component in a sheet instantiated more than once has one copy per
 * instantiation, and none of them is offered.
 */
export function wavesOfComponent(fs, ws, compId) {
    const matchValue = copiesOfCanvasComp(fs, compId);
    if (matchValue.tag === 0) {
        if (isInsideLibraryComponent(fs, matchValue.fields[0][1])) {
            return [empty(), 1];
        }
        else {
            const fId_2 = matchValue.fields[0];
            const waves = map((wi) => makeWave(ws, fs, wi), waveIndicesOfFComp(fs, fId_2[0], fId_2[1]));
            const matchValue_1 = FastSimulation__ComponentOf_6546966D(fs, fId_2);
            let matchResult;
            if (isEmpty(waves)) {
                if (matchValue_1 != null) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return [waveOfInstancePort(fs, ws, matchValue_1), 1];
                default:
                    return [waves, 1];
            }
        }
    }
    else {
        return [empty(), matchValue.fields[0]];
    }
}

function simLabelOfComponent(fs, compId) {
    const matchValue = copiesOfCanvasComp(fs, compId);
    if (matchValue.tag === 0) {
        const option_1 = FastSimulation__ComponentOf_6546966D(fs, matchValue.fields[0]);
        if (option_1 != null) {
            return option_1.FLabel;
        }
        else {
            return undefined;
        }
    }
    else {
        return undefined;
    }
}

/**
 * The waves to offer on the schematic's right-click menu for the component clicked on: none
 * unless a wave simulation is running and holds exactly one copy of that component.
 */
export function compWavesToOffer(model, compId) {
    const ws = getWSModel(model);
    const matchValue = model.WaveSimSheet;
    let matchResult, sheet_1;
    if (matchValue != null) {
        if (ws.State.tag === 5) {
            if (matchValue !== "") {
                matchResult = 0;
                sheet_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const matchValue_3 = wavesOfComponent(getFastSim(), ws, compId);
            if (matchValue_3[1] === 1) {
                return matchValue_3[0];
            }
            else {
                return empty();
            }
        }
        default:
            return empty();
    }
}

/**
 * The signal a wire of the open sheet carries, as an index into a simulation's waves.
 * 
 * A wire is driven by one output port, so the wire's value is that port's. Which copy of the port
 * depends on how many times the open sheet is instantiated in the design being simulated: with
 * more than one there is no single answer, so none is given - the same rule wavesOfComponent
 * applies to the schematic's right-click menu.
 */
export function waveIndexOfWire(fs, wireModel, cid) {
    const matchValue = tryFind(cid, wireModel.Wires);
    if (matchValue != null) {
        const matchValue_1 = tryFind(matchValue.OutputPort, wireModel.Symbol.Ports);
        if (matchValue_1 != null) {
            const port = matchValue_1;
            const matchValue_2 = port.PortNumber;
            if (matchValue_2 != null) {
                const portNum = matchValue_2 | 0;
                const matchValue_3 = copiesOfCanvasComp(fs, port.HostId);
                if (matchValue_3.tag === 1) {
                    return undefined;
                }
                else {
                    const fId = matchValue_3.fields[0];
                    return tryFind_1((wi) => {
                        if (equals(wi.PortType, PortType.Output)) {
                            return wi.PortNumber === portNum;
                        }
                        else {
                            return false;
                        }
                    }, waveIndicesOfFComp(fs, fId[0], fId[1]));
                }
            }
            else {
                return undefined;
            }
        }
        else {
            return undefined;
        }
    }
    else {
        return undefined;
    }
}

/**
 * The wave to offer on a wire's right-click menu: the signal the wire carries, when a wave
 * simulation is running and the open sheet has exactly one instance in its design - the same
 * rule compWavesToOffer applies to a component, answered by the same resolution the probe uses.
 */
export function wireWaveToOffer(model, cid) {
    const ws = getWSModel(model);
    const matchValue = model.WaveSimSheet;
    let matchResult, sheet_1;
    if (matchValue != null) {
        if (ws.State.tag === 5) {
            if (matchValue !== "") {
                matchResult = 0;
                sheet_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return waveIndexOfWire(getFastSim(), model.Sheet.Wire, cid);
        default:
            return undefined;
    }
}

/**
 * The value of one wave at one cycle, written as the waveform viewer's value column writes it.
 * 
 * The step index wraps: the step simulator uses its data arrays as a circular buffer, so a long
 * step simulation is holding only the last MaxArraySize cycles. The waveform simulator does not
 * wrap - its array is sized for the whole run - so there the modulo does nothing.
 * This one reads the given simulation DIRECTLY, and is the only value read left that does.
 * 
 * Not an oversight. The probe is handed whichever simulation it should answer from - the
 * waveform simulator's while one is running, and the STEP simulator's otherwise (MainView's
 * Probe.source) - and the cache models one active source, not a choice made per call. Routing
 * this through it would have the probe read the waveform simulation while the user is stepping
 * the other one. It goes through a provider when the step simulator gets one, which is also when
 * this stops working by reaching into a FastSimulation that .NET mode will not have.
 */
export function waveValueAt(fs, cycle, radix, wi) {
    let fd;
    const matchValue = tryItem(dToInt(wi.SimArrayIndex), fs.Drivers);
    let matchResult, driver;
    if (matchValue != null) {
        if (value_2(matchValue) != null) {
            matchResult = 0;
            driver = value_2(matchValue);
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const index = ((fs.MaxArraySize > 0) ? (cycle % fs.MaxArraySize) : cycle) | 0;
            let option_5;
            if (driver.DriverWidth > 32) {
                let option_1;
                const this$ = driver.DriverData;
                const step = index | 0;
                option_1 = (((this$.BigIntSlab.length === 0) ? true : ((step >>> 0) >= (this$.StepLength >>> 0))) ? undefined : (this$.BigIntSlab[(this$.StepBase + step)]));
                option_5 = ((option_1 != null) ? (new FastData(new FastBits(/* BigWord */ 1, [option_1]), driver.DriverWidth)) : undefined);
            }
            else {
                let option_3;
                const this$_1 = driver.DriverData;
                const step_1 = index | 0;
                option_3 = (((this$_1.UInt32Slab.length === 0) ? true : ((step_1 >>> 0) >= (this$_1.StepLength >>> 0))) ? undefined : (this$_1.UInt32Slab[(this$_1.StepBase + step_1)]));
                option_5 = ((option_3 != null) ? (new FastData(new FastBits(/* Word */ 0, [option_3]), driver.DriverWidth)) : undefined);
            }
            if (option_5 != null) {
                return (fd = option_5, fastDataToPaddedString(60, radix, fd).trim());
            }
            else {
                return undefined;
            }
        }
        default:
            return undefined;
    }
}

/**
 * What the schematic probe is asking about: which simulation, which wave, at which cycle, in
 * which radix - or None when it is asking nothing.
 * 
 * **Asked in one place and read in two**: the view that draws the label, and the pass that
 * fetches its value. Computed twice, they could differ, and a label would then be drawn from the
 * value of a different wire or a different cycle - which looks exactly like a correct answer.
 * 
 * The waveform simulator first: when both are running, its cursor is where the user has
 * deliberately put it, and it is the one they are looking at. The step simulator's clock tick is
 * simply how far it has been stepped, which is still the right answer when it is the only
 * simulation there is. And only while nothing is being dragged - during a gesture the pointer is
 * doing something else and a label following it is in the way.
 */
export function probeQuestion(model) {
    const ws = getWSModel(model);
    let source;
    if (ws.State.tag === 5) {
        source = [getFastSim(), ws.CursorExactClkCycle, ws.Radix];
    }
    else {
        const matchValue_1 = model.CurrentStepSimulationStep;
        let matchResult, simData;
        if (matchValue_1 != null) {
            const copyOfStruct = matchValue_1;
            if (copyOfStruct.tag === 0) {
                matchResult = 0;
                simData = copyOfStruct.fields[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                source = [simData.FastSim, simData.ClockTickNumber, simData.NumberBase];
                break;
            }
            default:
                source = undefined;
        }
    }
    const matchValue_2 = model.Sheet.HoveredWire;
    let matchResult_1, cid, cycle, fs, radix;
    if (matchValue_2 != null) {
        if (source != null) {
            if (model.Sheet.Action.tag === 11) {
                matchResult_1 = 0;
                cid = matchValue_2;
                cycle = source[1];
                fs = source[0];
                radix = source[2];
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
    }
    else {
        matchResult_1 = 1;
    }
    switch (matchResult_1) {
        case 0: {
            const option_1 = waveIndexOfWire(fs, model.Sheet.Wire, cid);
            if (option_1 != null) {
                return [fs, option_1, cycle, radix];
            }
            else {
                return undefined;
            }
        }
        default:
            return undefined;
    }
}

/**
 * The value the probe has been given for exactly the wave and cycle it is asking about.
 * 
 * None while the answer has not arrived, or has arrived for something else - a different wire, a
 * different cycle. The probe then draws nothing, which is right: a label showing the last wire's
 * value under the pointer on this one would look exactly like an answer.
 */
export function heldProbeValue(model, wi, cycle) {
    let heldCycle;
    const matchValue = model.ProbeRead;
    let matchResult, heldCycle_1, heldWave_1, value_1;
    if (matchValue != null) {
        if ((matchValue[2], (heldCycle = (matchValue[1] | 0), equals(matchValue[0], wi) && (heldCycle === cycle)))) {
            matchResult = 0;
            heldCycle_1 = matchValue[1];
            heldWave_1 = matchValue[0];
            value_1 = matchValue[2];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return value_1;
        default:
            return undefined;
    }
}

/**
 * What to write beside the cursor for the wire it is resting on: the signal's name and its value
 * at `cycle`. None when the simulation cannot answer - the wire is on a sheet it holds more than
 * one copy of, carries no wave of its own, or has not been simulated as far as this cycle.
 * 
 * The name without its sheet: the waveform viewer prefixes the sheet because its rows are drawn
 * away from the design and come from all over it, so a bare "Q" there could be any of them. Here
 * the label is on the wire, on the sheet the user is looking at, and the sheet name is the one
 * thing the position already says. It is also the longest part of the name, on a label that has
 * to fit beside the pointer without covering the circuit.
 */
export function probeLabelForWire(model, fs, cycle, radix, wireModel, cid) {
    let value, width, option_1, fd, text;
    const option_8 = waveIndexOfWire(fs, wireModel, cid);
    if (option_8 != null) {
        const wi = option_8;
        let option_6;
        if (model.SimulateInRenderer) {
            option_6 = waveValueAt(fs, cycle, radix, wi);
        }
        else {
            const option_4 = heldProbeValue(model, wi, cycle);
            option_6 = ((option_4 != null) ? ((value = option_4, (width = (defaultArg((option_1 = tryFind_1((p) => {
                if (equals(p.PortComp, wi.Id[0]) && equals(p.PortIs, wi.PortType)) {
                    return p.PortNum === wi.PortNumber;
                }
                else {
                    return false;
                }
            }, ofInstanceCached(fs, wi.Id[1]).ViewPorts), (option_1 != null) ? option_1.PortWidth : undefined), 1) | 0), (fd = ((width > 32) ? (new FastData(new FastBits(/* BigWord */ 1, [value]), width)) : (new FastData(new FastBits(/* Word */ 0, [toUInt32(value) >>> 0]), width))), fastDataToPaddedString(60, radix, fd).trim())))) : undefined);
        }
        if (option_6 != null) {
            return (text = option_6, concat(nameOfPort(fs, wi), " = ", text));
        }
        else {
            return undefined;
        }
    }
    else {
        return undefined;
    }
}

/**
 * The waves to show when a wave simulation starts with nothing chosen.
 * 
 * An empty viewer is never what the user wants: it makes the first thing they see after pressing
 * Start a sentence telling them to press a different button.
 * 
 * First choice is every Viewer in the design, because a Viewer is placed for one reason only -
 * somebody wanted to watch that net - so wherever they are, they are the signals the author of the
 * design thought were worth looking at. Which INSTANCE of a sheet each is taken from is the
 * selector's business, not this function's: the slice it is pointed at is what the user would see
 * if they opened Select Waves, and a default selection naming instances the selector is not
 * showing is one the user cannot find again.
 * 
 * With no Viewers anywhere, the top sheet's own ports - inputs and outputs, which are what a
 * design says about itself to whatever uses it.
 * 
 * A top sheet can have no ports at all: a whole CPU is often a ROM, a RAM and a couple of
 * subsystem instances, wired to each other and to nothing outside, which is what the `3cpu` demo's
 * `eep1` is. Then everything on the top sheet that carries a wave, which is the output of every
 * component drawn on it. That is a screenful on a large top sheet and it is still better than the
 * empty viewer it replaces, which explains itself to nobody.
 * 
 * All of them, at each stage, and not the first few: someone who placed thirty Viewers meant all
 * thirty. Read off the DESIGN - one instance of each sheet, since which Viewers a sheet has is a
 * fact about the sheet - and not off the waves, which on a large design number in the hundreds of
 * thousands.
 */
export function defaultSelectedWaves(fs, ws) {
    const chosen = (pick, instances) => collect((instance) => map((tuple_1) => tuple_1[1], sortBy((tuple) => tuple[0], waveIndicesOfInstanceBy(pick, fs, instance), {
        Compare: (x, y) => (compare(x, y) | 0),
    })), instances);
    const topSheet = empty();
    const matchValue_2 = chosen((comp_1) => {
        if (comp_1.Type.tag === 2) {
            return comp_1.Label;
        }
        else {
            return undefined;
        }
    }, selectorInstances(fs, ws));
    if (isEmpty(matchValue_2)) {
        const matchValue_3 = chosen((comp) => {
            const matchValue = comp.Type;
            switch (matchValue.tag) {
                case 0:
                    return [0, comp.Label];
                case 1:
                    return [1, comp.Label];
                default:
                    return undefined;
            }
        }, singleton(topSheet));
        if (isEmpty(matchValue_3)) {
            return waveIndicesOfInstance(fs, topSheet);
        }
        else {
            return matchValue_3;
        }
    }
    else {
        return matchValue_2;
    }
}

/**
 * Choose waves for a wave simulation that has none. Applied only when the user has selected
 * nothing at all - no waves and no RAMs - so a deliberately pared-down selection is never added
 * to, and a selection saved with the sheet is never overridden.
 */
export function withDefaultSelectionIfEmpty(fs, wsModel) {
    const matchValue = isEmpty(wsModel.SelectedWaves) && isEmpty_1(wsModel.SelectedRams);
    if (matchValue) {
        return new WaveSimModel(wsModel.DefaultCursor, wsModel.WSConfig, wsModel.WSConfigDialog, wsModel.State, wsModel.WaveDetails, defaultSelectedWaves(fs, wsModel), wsModel.DefaultSelectionPending, wsModel.FetchFailedAtMs, wsModel.StartCycle, wsModel.ShownCycles, wsModel.SamplingZoom, wsModel.CursorDisplayCycle, wsModel.CursorExactClkCycle, wsModel.ClkCycleBoxIsEmpty, wsModel.Radix, wsModel.WaveformColumnWidth, wsModel.WaveModalActive, wsModel.RamModalActive, wsModel.PortSelectComp, wsModel.RamComps, wsModel.SelectedRams, wsModel.RamStartLocation, wsModel.RamRows, wsModel.ShowSheetDetail, wsModel.SelectedSheetInstance, wsModel.ShowGroupDetail, wsModel.HoveredLabel, wsModel.DraggedIndex, wsModel.PrevSelectedWaves, wsModel.ScrollbarTbWidth, wsModel.ScrollbarTbPos, wsModel.ScrollbarTbOffset, wsModel.ScrollbarBkgWidth, wsModel.ScrollbarBkgRepCycs, wsModel.ScrollbarQueueIsEmpty, wsModel.SheetSearchString, wsModel.ComponentSearchString, wsModel.PortSearchString, wsModel.ShowOnlySelected);
    }
    else {
        return wsModel;
    }
}

/**
 * The same, for a simulation that is still OWED its default selection - which is what every
 * refresh of a started simulation asks, rather than the start asking once.
 * 
 * The choice reads the top instance's ports, and while the .NET simulator is simulating those are
 * not known until its first slice arrives: asking once, at the start, asked before there was
 * anything to answer with, and the viewer opened empty in the mode that ships. So it is asked
 * again until it has something to say - and then not again, which is what leaves a viewer the user
 * has emptied on purpose empty. See WaveSimModel.DefaultSelectionPending.
 */
export function withDefaultSelectionIfPending(fs, wsModel) {
    if (!wsModel.DefaultSelectionPending) {
        return wsModel;
    }
    else {
        const ws = withDefaultSelectionIfEmpty(fs, wsModel);
        return new WaveSimModel(ws.DefaultCursor, ws.WSConfig, ws.WSConfigDialog, ws.State, ws.WaveDetails, ws.SelectedWaves, isEmpty(ws.SelectedWaves) && isEmpty_1(ws.SelectedRams), ws.FetchFailedAtMs, ws.StartCycle, ws.ShownCycles, ws.SamplingZoom, ws.CursorDisplayCycle, ws.CursorExactClkCycle, ws.ClkCycleBoxIsEmpty, ws.Radix, ws.WaveformColumnWidth, ws.WaveModalActive, ws.RamModalActive, ws.PortSelectComp, ws.RamComps, ws.SelectedRams, ws.RamStartLocation, ws.RamRows, ws.ShowSheetDetail, ws.SelectedSheetInstance, ws.ShowGroupDetail, ws.HoveredLabel, ws.DraggedIndex, ws.PrevSelectedWaves, ws.ScrollbarTbWidth, ws.ScrollbarTbPos, ws.ScrollbarTbOffset, ws.ScrollbarBkgWidth, ws.ScrollbarBkgRepCycs, ws.ScrollbarQueueIsEmpty, ws.SheetSearchString, ws.ComponentSearchString, ws.PortSearchString, ws.ShowOnlySelected);
    }
}

/**
 * Modal that, when active, shows the ports of one component picked on the schematic, which of
 * them are displayed as waveforms, and allows that to be changed. Opened from the right-click
 * menu on that component.
 */
export function selectCompWavesModal(wsModel, dispatch) {
    const close = (_arg) => {
        dispatch(new Msg(/* UpdateWSModel */ 13, [(ws) => (new WaveSimModel(ws.DefaultCursor, ws.WSConfig, ws.WSConfigDialog, ws.State, ws.WaveDetails, ws.SelectedWaves, ws.DefaultSelectionPending, ws.FetchFailedAtMs, ws.StartCycle, ws.ShownCycles, ws.SamplingZoom, ws.CursorDisplayCycle, ws.CursorExactClkCycle, ws.ClkCycleBoxIsEmpty, ws.Radix, ws.WaveformColumnWidth, ws.WaveModalActive, ws.RamModalActive, undefined, ws.RamComps, ws.SelectedRams, ws.RamStartLocation, ws.RamRows, ws.ShowSheetDetail, ws.SelectedSheetInstance, ws.ShowGroupDetail, ws.HoveredLabel, ws.DraggedIndex, ws.PrevSelectedWaves, ws.ScrollbarTbWidth, ws.ScrollbarTbPos, ws.ScrollbarTbOffset, ws.ScrollbarBkgWidth, ws.ScrollbarBkgRepCycs, ws.ScrollbarQueueIsEmpty, ws.SheetSearchString, ws.ComponentSearchString, ws.PortSearchString, ws.ShowOnlySelected))]));
    };
    const matchValue = wsModel.PortSelectComp;
    if (matchValue != null) {
        const compId = matchValue;
        const fs = getFastSim();
        const waves = sortBy((wave) => [wave.WaveId.PortType, wave.WaveId.PortNumber], wavesOfComponent(fs, wsModel, compId)[0], {
            Compare: (x, y) => (compareArrays(x, y) | 0),
        });
        const compLabel = defaultArg(simLabelOfComponent(fs, compId), "component");
        const portsOfInstanceNote = !isEmpty(waves) ? ((head(waves).CompLabel !== compLabel) ? ofArray(["The signal is on the ", bSpan(head(waves).CompLabel), concat(" port of the sheet instance ", compLabel, " belongs to, which is where the waveform viewer shows it."), react.createElement("br", {}), react.createElement("br", {})]) : empty()) : empty();
        return modal(ofArray([new Option(/* IsActive */ 1, [true]), new Option(/* Props */ 0, [singleton(["style", {
            zIndex: 20000,
        }])])]), ofArray([background(singleton(new Common_GenericOption(/* Props */ 1, [singleton(new DOMAttr(/* OnClick */ 40, [close]))])), empty()), Card_card(singleton(new Common_GenericOption(/* Props */ 1, [singleton(["style", {
            width: 600,
        }])])), ofArray([Card_head(empty(), singleton(Card_title(empty(), singleton(level(empty(), ofArray([left(empty(), singleton(concat("Waveforms from ", compLabel))), right(empty(), singleton(delete$(ofArray([new Option_1(/* Size */ 0, [Size_ISize.IsMedium]), new Option_1(/* OnClick */ 3, [close])]), empty())))])))))), Card_body(empty(), append(portsOfInstanceNote, isEmpty(waves) ? singleton("No waveforms are available from this component.") : ofArray(["Ticked ports are shown in the waveform viewer. Use ", bSpan("Select Waves"), " for anything not on this component.", react.createElement("hr", {}), wavePropsTable(map((wave_3) => {
            let props_6, props_8, props_10, children_4, props_12, children_6;
            const isSelected = isWaveSelected(wave_3.WaveId, wsModel);
            const fontStyle = isSelected ? boldFontStyle : normalFontStyle;
            return waveRow(fontStyle, ofArray([(props_6 = [new HTMLAttr(/* Type */ 159, ["Checkbox"]), new HTMLAttr(/* Checked */ 62, [isSelected]), new DOMAttr(/* OnChange */ 9, [(_arg_1) => {
                toggleWaveSelection(wave_3.WaveId, wsModel, dispatch);
            }]), ["style", {
                marginLeft: "10px",
                marginRight: "10px",
            }]], react.createElement("input", keyValueList(props_6, 1))), (props_8 = [["style", keyValueList(fontStyle, 1)]], react.createElement("p", keyValueList(props_8, 1), wave_3.PortLabel)), (props_10 = [["style", keyValueList(fontStyle, 1)]], (children_4 = [(wave_3.WaveId.PortType.tag === 0) ? "Input" : "Output"], react.createElement("p", keyValueList(props_10, 1), ...children_4))), (props_12 = [["style", keyValueList(fontStyle, 1)]], (children_6 = [(wave_3.Width === 1) ? "1 bit" : (`${wave_3.Width} bits`)], react.createElement("p", keyValueList(props_12, 1), ...children_6)))]));
        }, waves))]))), Card_foot(empty(), empty())]))]));
    }
    else {
        return react.createElement("div", {});
    }
}

